import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormControlState,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  concat,
  defer,
  firstValueFrom,
  of,
} from 'rxjs';
import { STATE_TOKEN, StateModel } from '../../app.states';
import { SupportService } from 'apps/app-cic-ciam/src/services/support.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {
  faCheck,
  faTimes,
  faEyeSlash,
  faEye,
  faCircle,
  faArrowLeft,
  faShare,
  faShareFromSquare,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { environment } from 'apps/app-cic-ciam/src/environments/environment';
import { Router } from '@angular/router';
import { Choose2faPopupComponent } from '../../popup/choose-2fa-popup/choose-2fa-popup.component';
import {
  ClearEnrollResponses,
  EmailEnrollResponse,
  SmsEnrollResponse,
} from '../../app.actions';
import * as uuid from 'uuid';
import { Change2faPopupComponent } from '../../popup/change-2fa-popup/change-2fa-popup.component';
import { SmsVerifyPopupComponent } from '../../popup/sms-verify-popup/sms-verify-popup.component';
import { EmailVerifyPopupComponent } from '../../popup/email-verify-popup/email-verify-popup.component';
import { CountryDropdownComponent } from '../country-dropdown/country-dropdown.component';
import { Country } from '../../shared/country.model';
import { CommonValidators, phoneNumberWrapping } from '../../functions/utils';
import { SelfFactorService } from 'apps/app-cic-ciam/src/services/selffactor.service';
import { SmsCodeMode } from '../sms-code/sms-code.component';
import { EmailCodeMode } from '../email-code/email-code.component';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'ciciam-form-register',
  styleUrls: ['./form-register.component.scss'],
  templateUrl: './form-register.component.html',
})
export class FormRegisterComponent implements OnInit, OnDestroy {
  @ViewChild('mfaPopup') public mfaPopup!: Change2faPopupComponent;

  @Input() websiteName = 'Flowbite';
  factorEmailToken: string | undefined;
  factorPhoneToken: string | undefined;
  @Input() set message(stream: Observable<string | null>) {
    this.subscriptions.add(
      stream.subscribe((x) => this.messageSubject.next(x))
    );
  }
  @Input() pv: boolean = true;
  @Input() isTandC: boolean = true;
  @Input() mode: string = 'register';
  @Input() disableUserInfo: boolean = false;

  @Output() credential = new EventEmitter<any>();
  @Output() login: EventEmitter<any> = new EventEmitter();

  isLoading: boolean = false;

  isPasswordHasLowercase: boolean = false;
  isPasswordHasUppercase: boolean = false;
  isPasswordHasNumber: boolean = false;
  isPasswordLength8: boolean = false;
  isPasswordVisible: boolean = false;
  isRepeatPasswordVisible: boolean = false;

  isTandc1Read = false;
  isTandc1 = false;
  isTandc1Error = false;
  isTandc2Read = false;
  isTandc2 = false;
  isTandc2Error = false;
  noCompanyInfo = false;
  isSubmitted = false;

  faCheck = faCheck;
  faTimes = faTimes;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faCircle = faCircle;
  faBack = faArrowLeft;
  faGoto = faShareFromSquare;
  faEdit = faEdit;
  faCheckCircle = faCheckCircle;

  emailEnrollResponse: any = null;
  smsEnrollResponse: any = null;

  // isEmailVerified: boolean = false;
  // isPhoneVerified: boolean = false;
  verifiedEmail?: string | null;
  verifiedPhone?: string | null;

  isPhoneVerifyLoading: boolean = false;
  isEmailVerifyLoading: boolean = false;

  showEmailModal: boolean = false;
  showSmsModal: boolean = false;

  // reCAPTCHA state
  recaptchaV3Token: string = '';
  recaptchaV3TokenVerified: boolean = false;
  recaptchaV2: boolean = false;
  recaptchaV2Token: string = '';

  public steps = [
    { label: 'step1', icon: 'fas fa-user', active: false, completed: false },
    { label: 'step2', icon: 'fas fa-user', active: false, completed: false },
    { label: 'step3', icon: 'fas fa-user', active: false, completed: false },
  ];
  currentStep: number = 1;

  enabledButtonClasses = [
    'bg-notus-primary-600',
    'hover:bg-notus-primary-700',
    'focus:ring-notus-primary-300',
    'dark:bg-primary-600',
    'dark:hover:bg-primary-700',
    'dark:focus:ring-primary-800',
  ];
  loadingButtonClasses = [
    'bg-white',
    'ring-notus-primary-700',
    'ring-1',
    'cursor-default',
  ];
  disabledButtonClasses = ['cursor-not-allowed', 'bg-notus-primary-300'];

  @ViewChild('smsPopup') public smsPopup!: SmsVerifyPopupComponent;
  @ViewChild('emailPopup') public emailPopup!: EmailVerifyPopupComponent;

  smsMode: SmsCodeMode = SmsCodeMode.REGISTER;
  emailMode: EmailCodeMode = EmailCodeMode.REGISTER;

  language: string = 'zh-Hant';

  iamSmartOpenId?: string = undefined;
  authcachestate?: string = undefined;
  iamsmartInfo: any = null;
  form = this.fb.nonNullable.group({
    personalTitle: ['', Validators.required],

    firstName: ['', Validators.required],
    lastName: ['', Validators.required],

    firstNameZh: [''],
    lastNameZh: [''],

    email: ['', [Validators.email]],

    mobilePhone: [''],

    password: ['', Validators.required],
    repeatPassword: ['', Validators.required],

    companyName: ['', Validators.required],
    companyInd: ['', Validators.required],
    jobTitle: ['', Validators.required],

    noCompanyInfo: [false],

    // addrLine1: [''],
    // addrLine2: [''],
    // addrSubDistrict: [''],
    // addrDistrict: [''],
    // addrLine1Zh: [''],
    // addrLine2Zh: [''],
    // addrSubDistrictZh: [''],
    // addrDistrictZh: [''],
    // companyAddrLine1: [''],
    // companyAddrLine2: [''],
    // companyAddrSubDistrict: [''],
    // companyAddrDistrict: [''],
    // companyPhone: [''],
    // companyWebsite: [''],
    // fax: [''],
  });

  get formValues() {
    return this.form.getRawValue();
    return this.form.value;
  }

  get phoneErrorMessage() {
    const errors = this.form.controls.mobilePhone.errors;

    if (errors) {
      if (errors?.['phoneused']) {
        return 'Phone number had been used.';
      }
      if (errors?.['phoneformat']) {
        return 'Please enter a valid phone number.';
      }
      if (errors?.['phoneNotVerified']) {
        return 'Phone number is not verified.';
      }
      if (errors?.['ratelimit']) {
        return 'Too many attempts. Please try again in a minute.';
      }

      // return Object.keys(errors)
      //   .map((key) => {
      //     switch (key) {
      //       case 'phoneused':
      //         return 'Phone number had been used.';
      //       case 'phoneformat':
      //         return 'Please enter a valid phone number.';
      //       case 'phoneNotVerified':
      //         return 'Phone number is not verified.';

      //       default:
      //         return null;
      //     }
      //   })
      //   .filter((value) => !!value);
    }

    return null;
  }

  get isPhoneVerified(): boolean {
    return this.verifiedPhone
      ? this.form.controls.mobilePhone.value === this.verifiedPhone
      : false;
  }

  get isEmailVerified(): boolean {
    return this.verifiedEmail
      ? this.form.controls.email.value === this.verifiedEmail
      : false;
  }

  get shouldEnableVerifyEmailButton(): boolean {
    const emailControl = this.form.controls.email;

    const isControlValid =
      !(Validators.email(emailControl) ?? false) &&
      (emailControl.value ?? '') != '';

    // Button is disabled until reCAPTCHA is solved
    return isControlValid && this.isRecaptchaReady();
  }

  get shouldEnableVerifyPhoneButton(): boolean {
    const phoneControl = this.form.controls.mobilePhone;

    const isControlValid =
      !(CommonValidators.phone(phoneControl) ?? false) &&
      (phoneControl.value ?? '') != '';

    // Button is disabled until reCAPTCHA is solved
    return isControlValid && this.isRecaptchaReady();
  }

  get verifyEmailButtonClasses() {
    let _classes: string[] = [];

    if (!this.shouldEnableVerifyEmailButton) {
      _classes = this.disabledButtonClasses;
    }

    if (this.isEmailVerifyLoading) {
      _classes = _classes.concat(this.loadingButtonClasses);
    }

    if (this.isEmailVerified) {
      _classes = _classes.concat(['bg-white']);
    }

    return !_classes.length ? this.enabledButtonClasses : _classes;
  }

  get verifyPhoneButtonClasses() {
    let _classes: string[] = [];

    if (!this.shouldEnableVerifyPhoneButton) {
      _classes = this.disabledButtonClasses;
    }

    if (this.isPhoneVerifyLoading) {
      _classes = _classes.concat(this.loadingButtonClasses);
    }

    if (this.isPhoneVerified) {
      _classes = _classes.concat(['bg-white']);
    }

    return !_classes.length ? this.enabledButtonClasses : _classes;
  }

  private readonly messageSubject = new BehaviorSubject<string | null>(null);
  public readonly message$ = this.messageSubject.asObservable();

  private readonly subscriptions = new Subscription();
  private companyInfoOptionalControlSubscription?: Subscription;

  @Select(STATE_TOKEN) appState$!: Observable<StateModel>;

  // get isEmailVerified(): boolean {
  //   return this.emailEnrollResponse?.status == 'ACTIVE';
  // }
  // get isPhoneVerified(): boolean {
  //   return this.smsEnrollResponse?.status == 'ACTIVE';
  // }

  // areFactorsVerified(): boolean {
  //   return this.isEmailVerified() && this.isPhoneVerified();
  // }

  constructor(
    public translate: TranslateService,
    private readonly fb: FormBuilder,
    private http: HttpClient,
    private store: Store,
    private supportService: SupportService,
    private selfFactorService: SelfFactorService,
    private toastr: ToastrService,
    private router: Router,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  async ngOnInit() {
    // this.appState$.subscribe(async (state) => {
    //   this.emailEnrollResponse = state.emailEnrollResponse;
    //   this.smsEnrollResponse = state.smsEnrollResponse;
    //   if (state.emailEnrollResponse) {
    //     const email = this.emailEnrollResponse?.profile?.email;
    //     console.log(`EMAIL: ${email}; VERIFIED: ${this.isEmailVerified()}`);
    //     if ((email ?? '' != '') && this.isEmailVerified()) {
    //       let emailField = this.form.controls.email;
    //       emailField.setValue(email);
    //     }
    //   } else if (state.smsEnrollResponse) {
    //     const phone = this.emailEnrollResponse?.profile?.mobilePhone;
    //     console.log(`PHONE: ${phone}; VERIFIED: ${this.isPhoneVerified()}`);
    //     if ((phone ?? '' != '') && this.isPhoneVerified()) {
    //       let phoneField = this.form.controls.mobilePhone;
    //       phoneField.setValue(phone);
    //     }
    //   }
    // });

    if(this.mode !== 'register') {
      this.currentStep = 2;
    }

    const companyInfoRequiredControl = this.form.controls.noCompanyInfo

    if (companyInfoRequiredControl) {
      this.companyInfoOptionalControlSubscription = concat(
        defer(() => of(this.form.controls.noCompanyInfo?.value ?? null)),
        this.form.controls.noCompanyInfo?.valueChanges
      ).subscribe((_optional) => {
        this.checkNoCompanyInfo()
      });
    }

    // here we check if there is cookie "iamsmartopenid" exists
    if(window.location.pathname === '/register-iamsmart') {
      const iamsmartOpenIdCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith('iamsmartopenid='));
      if (iamsmartOpenIdCookie) {
        // if exists, we will call an API to get the user's name
        this.iamSmartOpenId = iamsmartOpenIdCookie.split('=')[1];
        // TODO: replace with actual API endpoint
        let iamsmartProfile = await this.supportService.getIamsmartProfile(this.iamSmartOpenId);
        console.log(iamsmartProfile);
        // {enFirstName: 'SIU MAN', enLastName: 'CHAN', chFirstName: '小文', chLastName: '陳'}

        if (iamsmartProfile) {
          this.iamsmartInfo = iamsmartProfile;
          this.form.controls.firstName.setValue(iamsmartProfile.enFirstName ?? '');
          this.form.controls.lastName.setValue(iamsmartProfile.enLastName ?? '');
          this.form.controls.firstNameZh.setValue(iamsmartProfile.chFirstName ?? '');
          this.form.controls.lastNameZh.setValue(iamsmartProfile.chLastName ?? '');
        }
      }
      const authcachestateCookie = document.cookie.split('; ').find((row) => row.startsWith('authcachestate='));
      if (authcachestateCookie) {
        this.authcachestate = authcachestateCookie.split('=')[1];
      }
    }

    this.appState$.subscribe(async (state) => {
      if (state.language) {
        this.language = state.language;
      }

      this.factorEmailToken = state.factorEmailToken;
      this.factorPhoneToken = state.factorPhoneToken;
    });

    // Initialize reCAPTCHA based on recaptchaMode config
    if (environment.recaptchaEnabled) {
    const recaptchaMode = environment.recaptchaMode ?? 'both';

    if (recaptchaMode === 'v3' || recaptchaMode === 'both') {
      this.recaptchaV3Service.execute('submit').subscribe({
        next: async (token) => {
          this.recaptchaV3Token = token;
          try {
            let validationResult = await this.supportService.recaptchaV3Validate(token);
            this.recaptchaV3TokenVerified = validationResult.success;
            if (!validationResult.success && recaptchaMode === 'both') {
              this.recaptchaV2 = true;
            }
          } catch (error) {
            if (recaptchaMode === 'both') {
              this.recaptchaV2 = true;
            }
          }
        },
        error: () => {
          if (recaptchaMode === 'both') {
            this.recaptchaV2 = true;
          }
        }
      });
    }

    if (recaptchaMode === 'v2') {
      this.recaptchaV2 = true;
    }
    }
  }

  isRecaptchaReady(): boolean {
    if (!environment.recaptchaEnabled) return true;

    const recaptchaMode = environment.recaptchaMode ?? 'both';

    switch (recaptchaMode) {
      case 'v3':
        return this.recaptchaV3TokenVerified;
      case 'v2':
        return this.recaptchaV2 && !!this.recaptchaV2Token;
      case 'both':
      default:
        // v3 passed OR (v3 failed and user solved v2)
        return this.recaptchaV3TokenVerified || (this.recaptchaV2 && !!this.recaptchaV2Token);
    }
  }

  async getRecaptchaTokens(): Promise<{ recaptchaV2Token: string; recaptchaV3Token: string }> {
    if (!environment.recaptchaEnabled) {
      return { recaptchaV2Token: '', recaptchaV3Token: '' };
    }

    const recaptchaMode = environment.recaptchaMode ?? 'both';

    // Refresh v3 token if needed
    if (recaptchaMode === 'v3' || recaptchaMode === 'both') {
      if (this.recaptchaV3TokenVerified || recaptchaMode === 'both') {
        try {
          const token = await this.recaptchaV3Service.execute('submit').toPromise();
          if (token) {
            this.recaptchaV3Token = token;
          }
        } catch (e) {
          // v3 failed, v2 fallback will handle it if mode is 'both'
        }
      }
    }

    return {
      recaptchaV2Token: this.recaptchaV2Token,
      recaptchaV3Token: this.recaptchaV3Token,
    };
  }

  onRecaptchaV2Resolve(token: string) {
    this.recaptchaV2Token = token;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.companyInfoOptionalControlSubscription?.unsubscribe();
  }

  setFormValue(obj: any) {
    let values = {
      personalTitle: obj.personalTitle ?? '',
      firstName: obj.firstName ?? '',
      lastName: obj.lastName ?? '',
      firstNameZh: obj.firstNameZh ?? '',
      lastNameZh: obj.lastNameZh ?? '',
      email: obj.email && !obj.email.endsWith('@cicciam.hk') ? obj.email : '',
      mobilePhone: obj.mobilePhone ? obj.mobilePhone.replace('+852', '') : '',
      // userIdentity: obj.userIdentity ?? '',
      companyName: obj.companyName ?? '',
      companyInd: obj.companyInd ?? '',
      jobTitle: obj.jobTitle ?? '',
      password: '',
      repeatPassword: '',
      noCompanyInfo: obj.noCompanyInfo ?? false,
    };

    if (this.mode != 'register') {
      this.form.controls.email.disable();
      this.form.controls.mobilePhone.disable();
      this.form.controls.email.clearValidators();
      this.form.controls.mobilePhone.clearValidators();
    }

    this.form.setValue({
      ...this.formValues,
      ...values,
    });

    this.checkNoCompanyInfo();
  }

  checkPassword($event: any) {
    let password = this.form.controls.password.value;

    this.isPasswordHasLowercase = /[a-z]/.test(password);
    this.isPasswordHasUppercase = /[A-Z]/.test(password);
    this.isPasswordHasNumber = /[0-9]/.test(password);
    this.isPasswordLength8 = password.length >= 8;
  }

  togglePassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleRepeatPassword() {
    this.isRepeatPasswordVisible = !this.isRepeatPasswordVisible;
  }

  async proceedWithSms2fa(phone?: string) {
    phone = phone ?? this.form.controls.mobilePhone.value;

    this.showSmsModal = true;

    phone = phoneNumberWrapping(phone);

    try {
      this.isPhoneVerifyLoading = true;

      let availabilityResult = await this.supportService.lookupUser(
        phone,
        ['phone number']
      );
      this.isPhoneVerifyLoading = false;
      if (availabilityResult !== false) {
        this.form.controls.mobilePhone.enable();
        this.form.controls.mobilePhone.setErrors({
          phoneused: 'regerror.phoneused',
        });

        return;
      }

      this.isPhoneVerifyLoading = true;

      const tokens = await this.getRecaptchaTokens();

      let result = await this.selfFactorService.selfSend2faSms(
        false,
        phone,
        undefined,
        tokens.recaptchaV2Token,
        tokens.recaptchaV3Token
      );

      if (!result || result.success == false) {
        this.form.controls.mobilePhone.enable();
        this.form.controls.mobilePhone.setErrors({
          phoneused: 'regerror.phoneused',
        });
      } else {
        this.store.dispatch(new SmsEnrollResponse(result));
        this.smsPopup.requestPrompt(async () => {
          this.showSmsModal = false;
          const factor =
            result.profile.phoneNumber ??
            phoneNumberWrapping(this.formValues.mobilePhone ?? '');
          this.form.controls.mobilePhone.setValue(factor);
          // this.form.controls.mobilePhone.disable();
          this.verifiedPhone = factor;
        });
      }
    } catch (e: any) {
      if (e?.status === 429) {
        // show a toast — toastr is available via DI in this component
        // fall through to store dispatch so the popup state is reset cleanly
        this.store.dispatch(new SmsEnrollResponse(null));
        // re-enable the field so the user can retry
        this.form.controls.mobilePhone.enable();
        // signal throttle via a form error that the template can render
        this.form.controls.mobilePhone.setErrors({ ratelimit: 'regerror.ratelimit' });
      } else {
        this.store.dispatch(new SmsEnrollResponse(e));
      }
    } finally {
      this.isPhoneVerifyLoading = false;
    }

    // this.router.navigate(['/register-validate']);
  }

  async proceedWithEmail2fa(email?: string) {
    email = email ?? this.form.controls.email.value!;

    if (email && !email.endsWith('@cicciam.hk')) {
      this.showEmailModal = true;

      try {
        this.isEmailVerifyLoading = true;

        let availabilityResult = await this.supportService.lookupUser(
          email,
          ["email"]
        );
        this.isEmailVerifyLoading = false;
        if (availabilityResult !== false) {
          this.form.controls.email.enable();
          this.form.controls.email.setErrors({
            emailused: 'regerror.emailused',
          });

          return;
        }

        this.isEmailVerifyLoading = true;

        const tokens = await this.getRecaptchaTokens();

        let result = await this.selfFactorService.selfSend2faEmail(
          false,
          email ?? this.form.controls.email.value ?? null,
          undefined,
          tokens.recaptchaV2Token,
          tokens.recaptchaV3Token
        );

        if (!result || result.success == false) {
          this.form.controls.email.setErrors({
            emailused: 'regerror.emailused',
          });
          this.form.controls.email.enable();
        } else {
          this.store.dispatch(new EmailEnrollResponse(result));
          this.emailPopup.requestPrompt(async () => {
            this.showEmailModal = false;
            const factor = result.email ?? this.formValues.email;
            this.form.controls.email.setValue(factor);
            // this.form.controls.email.disable();
            this.verifiedEmail = factor;
          });
        }
      } catch (e: any) {
        if (e?.status === 429) {
          this.store.dispatch(new EmailEnrollResponse(null));
          this.form.controls.email.enable();
          this.form.controls.email.setErrors({ ratelimit: 'regerror.ratelimit' });
        } else {
          this.store.dispatch(new EmailEnrollResponse(e));
        }
      } finally {
        this.isEmailVerifyLoading = false;
      }
    } else {
      this.store.dispatch(new EmailEnrollResponse(null));
    }

    // this.router.navigate(['/register-validate']);
  }

  on2faClick(method: string) {
    console.log(`on2faClick: ${method}`);

    // Block if reCAPTCHA is not yet solved
    if (!this.isRecaptchaReady()) {
      this.toastr.warning(this.translate.instant('Please complete the reCAPTCHA.'));
      return;
    }

    switch (method) {
      case 'sms':
        if (this.isPhoneVerified) {
          this.form.controls.mobilePhone.enable();
        } else {
          this.proceedWithSms2fa();
        }

        break;
      case 'email':
        if (this.isEmailVerified) {
          this.form.controls.email.enable();
          return;
        } else {
          this.proceedWithEmail2fa();
        }

        break;
      default:
        break;
    }
  }

  popup2faWith(method: string) {
    switch (method) {
      case 'sms':
        this.mfaPopup.requestPrompt(
          method,
          {
            profile: {
              phoneNumber: this.formValues.mobilePhone,
            },
            factorType: 'sms',
            provider: 'CUSTOM',
            status: 'INACTIVE',
          },
          // this.formValues.mobilePhone!,
          '',
          true,
          undefined,
          async (factor: any) => {
            if ((factor ?? '') != '') {
              this.form.controls.mobilePhone.setValue(factor);
              // this.form.controls.mobilePhone.disable();
              this.verifiedPhone = factor;
            } else {
              this.form.controls.mobilePhone.enable();
            }
          },
          true
        );
        break;
      case 'email':
        this.mfaPopup.requestPrompt(
          method,
          {
            profile: {
              email: this.formValues.email!,
            },
            factorType: 'email',
            provider: 'CUSTOM',
            status: 'INACTIVE',
          },
          // this.formValues.email!,
          '',
          true,
          undefined,
          async (factor: any) => {
            if ((factor ?? '') != '') {
              this.form.controls.email.setValue(factor);
              // this.form.controls.email.disable();
              this.verifiedEmail = factor;
            } else {
              this.form.controls.email.enable();
            }
          },
          true
        );
        break;
    }
  }

  onTandc1Scroll($event: any) {
    if (
      $event.target.offsetHeight + $event.target.scrollTop >=
      $event.target.scrollHeight
    ) {
      this.isTandc1Read = true;
    }
  }

  onTandc1Change($event: any) {
    if (!this.isTandc1Read) {
      $event.srcElement.checked = false;
      this.isTandc1Error = true;
      return;
    }
    this.isTandc1 = $event.srcElement.checked;
    this.isTandc1Error = false;
  }

  onTandc2Scroll($event: any) {
    if (
      $event.target.offsetHeight + $event.target.scrollTop >=
      $event.target.scrollHeight
    ) {
      this.isTandc2Read = true;
    }
  }

  onTandc2Change($event: any) {
    if (!this.isTandc2Read) {
      $event.srcElement.checked = false;
      this.isTandc2Error = true;
      return;
    }
    this.isTandc2 = $event.srcElement.checked;
    this.isTandc2Error = false;
  }

  onNoCompanyInfoChange($event?: any) {
    // this.noCompanyInfo = $event.srcElement.checked;
    if (!$event) {
      this.form.controls.noCompanyInfo.setValue(!this.formValues.noCompanyInfo);
    }
    this.checkNoCompanyInfo();
  }

  checkNoCompanyInfo() {
    if (this.form.controls.noCompanyInfo.value) {
      this.form.controls.companyName.disable();
      this.form.controls.companyInd.disable();
      this.form.controls.jobTitle.disable();
      this.form.controls.companyName.clearValidators();
      this.form.controls.companyInd.clearValidators();
      this.form.controls.jobTitle.clearValidators();
      this.form.controls.companyName.updateValueAndValidity();
      this.form.controls.companyInd.updateValueAndValidity();
      this.form.controls.jobTitle.updateValueAndValidity();
    } else if (!this.disableUserInfo) {
      this.form.controls.companyName.enable();
      this.form.controls.companyInd.enable();
      this.form.controls.jobTitle.enable();
      this.form.controls.companyName.setValidators([Validators.required]);
      this.form.controls.companyInd.setValidators([Validators.required]);
      this.form.controls.jobTitle.setValidators([Validators.required]);
      this.form.controls.companyName.updateValueAndValidity();
      this.form.controls.companyInd.updateValueAndValidity();
      this.form.controls.jobTitle.updateValueAndValidity();
    }
  }

  async onRegisterWithEmail() {
    this.messageSubject.next(null);

    this.form.setErrors(null);

    this.isSubmitted = true;

    this.form.controls.email.setErrors(null);
    this.form.controls.mobilePhone.setErrors(null);
    this.form.controls.repeatPassword.setErrors(null);

    this.form.controls.personalTitle.markAsTouched();
    this.form.controls.firstName.markAsTouched();
    this.form.controls.lastName.markAsTouched();
    this.form.controls.email.markAsTouched();
    this.form.controls.mobilePhone.markAsTouched();
    this.form.controls.password.markAsTouched();
    this.form.controls.repeatPassword.markAsTouched();
    this.form.controls.companyName.markAsTouched();
    this.form.controls.companyInd.markAsTouched();
    this.form.controls.jobTitle.markAsTouched();

    if (
      !(
        this.isPasswordHasLowercase &&
        this.isPasswordHasUppercase &&
        this.isPasswordHasNumber &&
        this.isPasswordLength8
      )
    ) {
      this.form.controls.password.setErrors({
        requirement: 'regerror.password',
      });
    }

    if (
      this.form.controls.email.value == '' &&
      this.form.controls.mobilePhone.value == ''
    ) {
      this.form.setErrors({ emailandphonemissing: 'error' });
      this.form.controls.email.setErrors({
        emailandphonemissing: 'error',
      });
      this.form.controls.mobilePhone.setErrors({
        emailandphonemissing: 'error',
      });
    }

    if (this.form.controls.email.value != '') {
      if (!this.isEmailVerified) {
        this.form.controls.email.setErrors({
          emailNotVerified: 'regerror.emailNotVerified',
        });
      }
    }

    if (this.form.controls.mobilePhone.value != '') {
      if (!this.isPhoneVerified) {
        this.form.controls.mobilePhone.setErrors({
          phoneNotVerified: 'regerror.phoneNotVerified',
        });
      }
    }

    if (!this.form.valid) {
      return;
    }

    // this.credential.emit(payload);

    let formValue = this.formValues;

    let password = formValue.password;
    let repeatPassword = formValue.repeatPassword;

    if (password !== repeatPassword) {
      // TODO: show error message
      this.form.controls.repeatPassword.setErrors({
        match: 'error',
      });
      return;
    }

    this.setIsLoading(true);

    // check if email already used
    try {
      if (formValue.email) {
        var emailSearch = await this.supportService.lookupUser(
          formValue.email,
          ["email"]
        );
        if (emailSearch !== false) {
          this.setIsLoading(false);
          this.form.controls.email.setErrors({
            emailused: 'regerror.emailused',
          });
          return;
        }
      }

      // check if phone number already used
      if (formValue.mobilePhone) {
        var phoneSearch = await this.supportService.lookupUser(
          formValue.mobilePhone,
          ['phone number']
        );
        if (phoneSearch !== false) {
          this.setIsLoading(false);
          this.form.controls.mobilePhone.setErrors({
            phoneused: 'regerror.phoneused',
          });
          return;
        }
      }
    } catch (error) {}

    this.setIsLoading(false);

    this.currentStep = 3;
  }

  onRegisterStep2Confirm() {
    this.currentStep = 2;
  }

  onRegisterStep2Back() {
    this.currentStep = 1;
  }

  onRegisterStep3Back() {
    this.currentStep = 2;
  }

  async onRegisterStep3Confirm() {
    this.setIsLoading(true);

    let formValue = this.formValues;
    let password = formValue.password;
    let emailVerifyToken = this.factorEmailToken;
    let mobileVerifyToken = this.factorPhoneToken;

    if (formValue.mobilePhone) {
      formValue.mobilePhone = phoneNumberWrapping(formValue.mobilePhone);
    }

    if (!formValue.email) {
      formValue.email = formValue.mobilePhone + '@cicciam.hk';
    }

    let payload = {
      profile: {
        ...formValue,
        login: formValue.email ? formValue.email : formValue.mobilePhone,
        mobilePhone: formValue.mobilePhone ? formValue.mobilePhone : '',
      },
      credentials: {
        password: { value: password },
      },
    };

    delete payload.profile.password;
    delete payload.profile.repeatPassword;

    let deviceToken = localStorage.getItem('deviceToken');
    if (deviceToken == null) {
      deviceToken = uuid.v4().substring(0, 32);
      localStorage.setItem('deviceToken', deviceToken);
    }

    try {
      var result = await this.supportService.register({
        personalTitle: formValue.personalTitle ?? '',
        firstName: formValue.firstName ?? '',
        lastName: formValue.lastName ?? '',
        firstNameZh: formValue.firstNameZh ?? '',
        lastNameZh: formValue.lastNameZh ?? '',
        email: formValue.email,
        emailVerifyToken: emailVerifyToken ?? '',
        mobilePhone: formValue.mobilePhone ?? '',
        mobileVerifyToken: mobileVerifyToken ?? '',
        password: password ?? '',
        companyName: formValue.companyName ?? '',
        companyInd: formValue.companyInd ?? '',
        jobTitle: formValue.jobTitle ?? '',
        noCompanyInfo: formValue.noCompanyInfo ?? false,
        deviceToken: deviceToken ?? uuid.v4().substring(0, 32),
        iamSmartOpenId: this.iamSmartOpenId ?? undefined,
      });

      // if(formValue.email?.endsWith('@cicciam.hk')) {
      //   await this.supportService.removeEmail2fa(data.id);
      // }

      // this.isLoading = false;

      if (result == undefined || result.success != true) {
        if (result != undefined && result.errorCode != undefined) {
          if (result.errorCode == 'E0000001') {
            this.toastr.error(
              this.translate.instant(
                'Your password seems contains part of your email / phone number, please modify and try again'
              ),
              this.translate.instant('Error')
            );
            this.currentStep = 2;
          } else {
            this.toastr.error(
              this.translate.instant(
                'Action failed, please try again ({{errorcode}})',
                { errorcode: result.errorCode }
              ),
              this.translate.instant('Error')
            );
          }
        }
      }

      if (result != undefined && result.success == true) {
        if(this.iamSmartOpenId && this.authcachestate && window.location.pathname === '/register-iamsmart') {
          // if iamsmartOpenId and authcachestate exists, we will redirect to iamsmart login page
          window.location.href = `${environment.iamsmartDomain}binding/complete?openid=${encodeURIComponent(this.iamSmartOpenId ?? '')}&authcachestate=${encodeURIComponent(this.authcachestate ?? '')}`;
          return;
        }
        this.credential.emit({
          isSuccess: true,
          data: result,
          email: '',
          firstName: '',
          lastName: '',
          mobilePhone: '',
          ...this.formValues,
          password: password,
        });
      } else {
        this.setIsLoading(false);
      }
    } catch (err: any) {
      console.log(err);

      this.setIsLoading(false);

      let errorMessages: string[] = [];

      if (err.error.errorCauses && err.error.errorCauses.length > 0) {
        for (let errorCause of err.error.errorCauses) {
          if (errorCause.errorSummary) {
            if (errorCause.errorSummary.includes('password')) {
              errorMessages = [
                ...errorMessages,
                this.translate.instant('regerror.password'),
              ];
              this.form.controls.password.setErrors({
                requirement: 'regerror.password',
              });
            } else if (
              errorCause.errorSummary.includes(
                'An object with this field already exists in the current organization'
              ) ||
              errorCause.errorSummary.includes(
                '目前的組織已存在使用此欄位的物件'
              )
            ) {
              errorMessages = [
                ...errorMessages,
                this.translate.instant('regerror.emailorphoneused'),
              ];
              this.form.setErrors({
                emailorphoneused: 'regerror.emailorphoneused',
              });
            } else {
              errorMessages = [...errorMessages, errorCause.errorSummary];
              this.form.setErrors({ error: errorCause.errorSummary });
            }
          }
        }
      }

      this.toastr.error(
        errorMessages.join('<br />'),
        this.translate.instant('Error'),
        {
          enableHtml: true,
        }
      );
    }
  }

  async onUpdateProfile() {
    this.messageSubject.next(null);

    this.form.controls.password.clearValidators();
    this.form.controls.password.updateValueAndValidity();
    this.form.controls.repeatPassword.clearValidators();
    this.form.controls.repeatPassword.updateValueAndValidity();

    this.form.controls.personalTitle.markAsTouched();
    this.form.controls.firstName.markAsTouched();
    this.form.controls.lastName.markAsTouched();
    this.form.controls.email.markAsTouched();
    this.form.controls.mobilePhone.markAsTouched();
    this.form.controls.companyName.markAsTouched();
    this.form.controls.companyInd.markAsTouched();
    this.form.controls.jobTitle.markAsTouched();

    this.form.setErrors(null);
    this.form.updateValueAndValidity();

    if (!this.form.valid) {
      return;
    }

    // this.credential.emit(payload);

    let formValue = this.formValues;

    delete formValue.email;
    delete formValue.mobilePhone;
    delete formValue.password;
    delete formValue.repeatPassword;

    this.setIsLoading(true);

    let result = await this.supportService.updateUserProfile(formValue);

    // TODO: check update success?

    this.setIsLoading(false);

    this.toastr.success(this.translate.instant('Update profile success'));

    this.credential.emit({
      isSuccess: true,
      data: result,
      email: '',
      firstName: '',
      lastName: '',
      mobilePhone: '',
      password: '',
      ...this.formValues,
    });

    if (this.mode != 'register') {
      this.form.controls.email.disable();
      this.form.controls.mobilePhone.disable();
      this.form.controls.email.clearValidators();
      this.form.controls.mobilePhone.clearValidators();
    }
  }

  onLogin($event: any) {
    $event.preventDefault();
    this.login.emit();
  }

  setIsLoading(isLoad: boolean) {
    this.isLoading = isLoad;
    if (isLoad) {
      this.form.disable();
    } else {
      this.form.enable();
      this.checkNoCompanyInfo();
    }
  }

  gotoSecurityPage() {
    this.router.navigate(['/home/security']);
  }

  isSurnameFromIamSmart(): boolean {
    return this.iamsmartInfo && this.iamsmartInfo.enLastName && this.iamsmartInfo.enLastName.length > 0 && this.form.controls.lastName.value == this.iamsmartInfo.enLastName;
  }

  isGivenNameFromIamSmart(): boolean {
    return this.iamsmartInfo && this.iamsmartInfo.enFirstName && this.iamsmartInfo.enFirstName.length > 0 && this.form.controls.firstName.value == this.iamsmartInfo.enFirstName;
  }

  isCSurnameFromIamSmart(): boolean {
    return this.iamsmartInfo && this.iamsmartInfo.chLastName && this.iamsmartInfo.chLastName.length > 0 && this.form.controls.lastNameZh.value == this.iamsmartInfo.chLastName;
  }

  isCGivenNameFromIamSmart(): boolean {
    return this.iamsmartInfo && this.iamsmartInfo.chFirstName && this.iamsmartInfo.chFirstName.length > 0 && this.form.controls.firstNameZh.value == this.iamsmartInfo.chFirstName;
  }
}
